import { useRouter } from 'next/router';
import Carousels from 'src/components/carousels';
import Image from 'src/components/image';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { convertDataLists } from 'src/utils/datasets';
import useResponsive from 'src/utils/devices';
import styled from 'styled-components';

const SectionWebull = ({ id, data }) => {
  const responsive = useResponsive();
  const image = { ...convertDataLists(data?.dataSet, ['imgDesktop-', 'imgMobile-']) };
  const linkWebull = { ...convertDataLists(data?.dataSet, ['link-']) };

  const images = !responsive.isMobile ? image?.imgDesktop ?? [] : image?.imgMobile ?? [];
  const router = useRouter();
  return (
    <SectionWrapper className='' id={id}>
      <Carousels
        // heading='ข่าวที่น่าสนใจ'
        showDots={false}
        autoPlay={true}
        responsiveShow={1}
      >
        {images.map((image, index) => (
          <div className='carousels-webull' key={index}>
            {linkWebull?.link[index] ? <a
              href={linkWebull?.link[index]}
              onClick={() => sendDataLayerGlobal({
                type: DATALAYER_TYPE.TRACK_POSITION,
                router: router?.pathname,
                section: 'section-spacial',
                position: 'ใต้:section-4',
                data: {
                  heading: 'section-spacial',
                  title: linkWebull?.link[index],
                  carousel: index + 1
                }
              })}
              //! DATALAYER
              target='_blank'
              rel='noopener noreferrer nofollow'
              className='card-wrapper'
            >
              <Image external={true} image={image} title={'webull'} type='COVER_IMAGE' />
            </a> : <div><Image external={true} image={image} title={'webull'} type='COVER_IMAGE' /></div>}
          </div>
        ))}
      </Carousels>
    </SectionWrapper>
  );
};

export default SectionWebull;

const SectionWrapper = styled.div`
  padding-top: 30px;
  .carousel-wrapper {
    margin: 35px 0px 0px 0px;
    display: block;
    // img {
    // :hover {
    //   transform: scale(1.1);
    // }
    // }
  }
  .slick-slide img {
    border-radius: 0px;
  }
`;
